import { useEffect, useState } from "react";
import { Course } from "../const/types";
import { HStack, Icon, VStack } from "@chakra-ui/react";
import Container from "../components/Container";
import Nav from "../components/nav/Nav";
import { useParams } from "react-router-dom";
import cr from "../lib/request";
import ComponentSpinner from "../components/spinner/ComponentSpinner";
import SilabusWatch from "../components/player/SilabusWatch";
import Footer from "../components/Footer";
import ExpandableCourseDescription from "../components/card/ExpandableCourseDescription";
import { Student } from "@phosphor-icons/react";
import ShareCourse from "../components/ShareCourse";

export default function MycourseWatch() {
  const [data, setData] = useState<Course | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { course_id } = useParams();

  useEffect(() => {
    if (course_id) {
      setLoading(true);
      const url = `api/usercourse/${course_id}/detailcourse`;
      cr.get(url)
        .then((r) => {
          if (r.status === 200) {
            setData(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [course_id]);

  return (
    <VStack
      minH={"100vh"}
      w={"100%"}
      gap={0}
      bgImage={`${process.env.REACT_APP_MEDIA_BASE_URL}${data?.image}`}
      bgSize={"cover"}
      bgPos={"center bottom"}
      bgAttachment={"fixed"}
    >
      <VStack
        backdropFilter={"blur(10px)"}
        w={"100%"}
        bg={
          "linear-gradient(180deg,  RGBA(255, 255, 255, 0.80), #FFFFFF, #FFFFFF)"
        }
      >
        <Nav />

        {!loading && data ? (
          <Container mx={"auto"} py={5}>
            {/* <VStack mb={5} maxW={"300px"}>
              <Image
                borderRadius={12}
                src={`${process.env.REACT_APP_MEDIA_BASE_URL}${data?.image}`}
              />
            </VStack> */}
            <HStack justify={"space-between"}>
              <Icon as={Student} fontSize={58} mb={4} weight="fill" />

              <ShareCourse data={data} />
            </HStack>

            <ExpandableCourseDescription data={data} mb={5} />

            <SilabusWatch course={data} />
          </Container>
        ) : (
          <ComponentSpinner minH={"calc(100vh - 72px)"} />
        )}

        <Footer />
      </VStack>
    </VStack>
  );
}
